import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import useNear from "../hooks/nearHook";
import useSbt from "../hooks/sbtHook";
import useSbtPermissions from "../hooks/sbtPermissionsHook";
import useSbtMarketplace from "../hooks/sbtMarketplaceHook";
import useTokenRouting from "../hooks/tokenRoutingHook";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ReactJson from "react-json-view";
import SbtMetadataTable from "../components/SbtMetadataTable";
import SbtSelector from "../components/SbtSelector";
import SbtTokenListTable from "../components/SbtTokenListTable";
import AccountField from "../components/AccountField";
import SbtPermissionSelector from "../components/SbtPermissionSelector";
import IconButton from "@mui/material/IconButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { useNavigate } from "react-router-dom";
import { utils } from "near-api-js";

const MarketplaceGrantDashboard = ({}) => {
  const near = useNear();
  const perms = useSbtPermissions();
  const marketplace = useSbtMarketplace();

  const [marketplaceOffers, setMarketplaceOffers] = useState([]);
  const [marketplaceListings, setMarketplaceListings] = useState([]);
  const [sbtPermsMetadata, setSbtPermsMetadata] = useState({});
  const {
    contractId,
    accountId,
    selectedTokenId,
    setContractId,
    setAccountId,
    setSelectedTokenId,
  } = useTokenRouting();
  const [price, setPrice] = useState("");

  useEffect(() => {
    setAccountId(near.account.account);
  }, [accountId, near.account.account]);

  useEffect(() => {
    console.log("updating offers")
    if (!contractId || !near.account.account, !accountId) {
      setMarketplaceOffers([]);
      return;
    }
    console.log(contractId, accountId);
    marketplace.getOffers(contractId, accountId).then((result) => {
      console.log("offers", result);
      setMarketplaceOffers(result.map(offer => ({...offer, id: `${offer.listing_id}-${offer.offering_account_id}`})));

      setSelectedTokenId(null);
    });
    marketplace.getListings(contractId).then((result) => {
      setMarketplaceListings(result);
    });
  }, [contractId, near.account.account, accountId]);

  useEffect(() => {
    if (!contractId || !near.account.account) {
      setSbtPermsMetadata({});
      return;
    }
    perms.getContractMetadata(contractId).then(setSbtPermsMetadata);
  }, [contractId, near.account.account]);

  const disabled = !selectedTokenId;
  const selectedOffer = marketplaceOffers.find(l => l.id == selectedTokenId);
  const selectedFullOffer = selectedOffer && {
    ...selectedOffer,
    listing: marketplaceListings.find(l => l.id == selectedOffer.listing_id)
  }

  const grantPermissions = () => {
    if(!selectedTokenId || !contractId){
      return;
    }
    const listing = marketplaceListings.find(l => l.id == selectedOffer.listing_id);
    const tokenLocators = listing.tokens;
    const accounts = [selectedOffer.offering_account_id];

    console.log(listing, tokenLocators, accounts);

    marketplace.acceptOffer(contractId, selectedOffer.listing_id, tokenLocators, accounts);
  }
  
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 450,
            }}
          >
            <SbtPermissionSelector
              sbtAuthContractId={contractId}
              setSbtAuthContractId={setContractId}
            />
            <SbtMetadataTable sbtMetadata={sbtPermsMetadata} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <AccountField
              accountId={accountId}
              setAccountId={setAccountId}
              disabled
            />
            <SbtTokenListTable
              sbtTokens={marketplaceOffers}
              onSelect={setSelectedTokenId}
              title="Offers"
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <ReactJson
              src={selectedFullOffer || {}}
              name={false}
              style={{ overflow: "auto" }}
              enableClipboard={false}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
        <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <Button variant="contained" onClick={grantPermissions} disabled={disabled}>
              Grant permission
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MarketplaceGrantDashboard;
